import { allWaterMakerMetricNames } from '@shared_types/metrics/watermaker_metrics'
import { initializeMetrics } from '@shared_utils/metric_utils'

import { LOAD_WATERMAKERS, UPDATE_WATERMAKERS } from '../actions'

const initialState = initializeMetrics(allWaterMakerMetricNames)

// @TODO fix types
export default function init (previousState = initialState, { type, payload }: { type: string; payload: unknown }) {
  if (type === LOAD_WATERMAKERS || type === UPDATE_WATERMAKERS) {
    console.log('init watermaker_metrics', payload)
    return Object.assign({}, previousState, payload)
  } else {
    return previousState
  }
}
